export default function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px', zIndex: 1000,
      backdropFilter: 'blur(2px)',
      fontFamily: "'Segoe UI', sans-serif",
    }}>
      <div className="gs-modal-box" style={{
        background: '#fff', borderRadius: '16px',
        padding: '28px 28px 24px', width: '100%', maxWidth: '440px',
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
        animation: 'fadeIn 0.15s ease',
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: '20px', paddingBottom: '14px',
          borderBottom: '2px solid #f1f5f9',
        }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#0f172a' }}>{title}</h2>
          <button
            onClick={onClose}
            style={{
              background: '#f1f5f9', border: 'none', borderRadius: '8px',
              width: '32px', height: '32px', cursor: 'pointer',
              fontSize: '18px', color: '#64748b', display: 'flex',
              alignItems: 'center', justifyContent: 'center', lineHeight: 1,
            }}
          >
            &times;
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}